import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import Alerta from "../../components/alerta/Alerta";
import style from "./Avisos.module.css";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import Loader from "../../components/loader/Loader";
import { Button, Form, Modal } from "react-bootstrap";
import { MdClose, MdDelete, MdSearch } from "react-icons/md";
import AvisoApi from "../../services/AvisoApi";
import UsuarioApi from "../../services/UsuarioApi";
import Paginacao from "../../components/paginacao/Paginacao";
import { Link } from "react-router-dom";
import { IoEyeSharp } from "react-icons/io5";
import { TiDelete } from "react-icons/ti";
import BotaoNovoAtualizado from "../../components/botaoNovoAtualizado/BotaoNovoAtualizado";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Avisos() {
    //Modais para adicionar, visualizar e excluir
    const [mostarModalDeletar, setMostarModalDelatar] = useState(false);
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);
    const [adicionar, setAdicionar] = useState(false);
    const [remover, setRemover] = useState(false);
    const [visualizar, setVisualizar] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);
    const [coordenadores, setCoordenadores] = useState([]);
    const [avisoVisualizar, setAvisoVisualizar] = useState(null);
    const [avisoSelecionado, setAvisoSelecionado] = useState(null);
    const [avisoId, setAvisoId] = useState(null);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    //Para rodar a tabela, paginação e filtro
    const [avisos, setAvisos] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [titulo, setTitulo] = useState("");
    const [descricao, setDescricao] = useState("");
    const [tituloFiltro, setTituloFiltro] = useState("");
    const [descricaoFiltro, setDescricaoFiltro] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);

    //Novo aviso
    const [novoTitulo, setNovoTitulo] = useState("");
    const [novaDescricao, setNovaDescricao] = useState("");
    const [tipoAvisoEnum, setTipoAvisoEnum] = useState(null);

    //Para o loader
    const [loading, setLoading] = useState(false);

    //Tipos de avisos Adm
    const [tiposAvisoAdministradorEnum, setTiposAvisoAdministradorEnum] = useState([
        { key: 6, value: "Enviar aviso para todos os usuários." },
        { key: 7, value: "Enviar aviso para todos os coordenadores." },
        { key: 8, value: "Enviar aviso para um ou mais coordenadores específicos." }
    ]);

    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    //Função para fechar o modal
    const FecharModal = () => {
        setMostrarModal(false);
        setAvisoSelecionado(null);
        setRemover(false);
        setAdicionar(false);
        setVisualizar(false);
        setAvisoId(null)
        setAvisoVisualizar(null);
        setNovoTitulo(null);
        setNovaDescricao(null);
        setTitulo(null);
        setDescricao(null);
        setTipoAvisoEnum(null);
    };

    //Função para filtro de busca
    async function BuscarAvisos() {
        setTitulo(tituloFiltro);
        setDescricao(descricaoFiltro);
        setPaginaAtual(1);
        CarregarAvisos(1, tituloFiltro, descricaoFiltro);
    }

    //Função para resetar  filtro de busca
    async function ResetarAvisos() {
        setTitulo("");
        setDescricao("");
        setTituloFiltro("");
        setDescricaoFiltro("");
        setPaginaAtual(1);
        CarregarAvisos(1, "", "");
    }

    //Função para carregar os avisos
    async function CarregarAvisos(paginaAtual, titulo, descricao) {
        try {
            const listaAvisos = await AvisoApi.ListarAvisosComPaginacaoAsync(
                paginaAtual, 
                titulo, 
                descricao
            );
            setQuantidadeItens(listaAvisos.quantidadeRegistros);
            setAvisos(listaAvisos.registros);
        } catch (error) {
            console.error("Erro ao carregar usuários:", error.response.data);
        }
    }

    function ModalAdicionar() {
        setLoading(true);
        setAdicionar(true);
        setUsuariosSelecionados([]);
        setMostrarModal(true);
        setLoading(false);
    }

    async function ModalVisualizar(Aviso) {
        setLoading(true);
        setAvisoSelecionado(Aviso);
        setAvisoId(Aviso.avisoID);
        const aviso = await AvisoApi.VisualizarAvisoAsync(Aviso.avisoID);
        setAvisoVisualizar(aviso);
        setVisualizar(true);
        setMostrarModal(true);
        setLoading(false);
    }

    function ModalExcluir(Aviso) {
        setLoading(true);
        setAvisoSelecionado(Aviso);
        setAvisoId(Aviso.avisoID)
        setRemover(true);
        setMostrarModal(true);
        setLoading(false);
    }

    async function ExcluirAviso() {
        try {
            setLoading(true);
            await AvisoApi.RemoverAvisoAsync(avisoId);
            if (paginaAtual > 1 && avisos.length === 1) {
                setPaginaAtual(paginaAtual - 1);
            }
            CarregarAvisos();
            setMensagemAlerta(`Aviso excluido com sucesso!`);
            setTipoAlerta('success');
        }
        catch (error) {
            setMensagemAlerta(`Erro ao excluir a Aviso: ${error.response.data}`);
            setTipoAlerta('danger');
        }
        finally {
            FecharModal();
            setLoading(false);
            exibirAlerta();
        }
    }

    function ModalAdicionar() {
        setLoading(true);
        setAdicionar(true);
        setUsuariosSelecionados([]);
        setMostrarModal(true);
        setLoading(false);
    }

    async function AdicionarAviso() {
        try {
            setLoading(true);
            await AvisoApi.CriarAvisoAsync(novoTitulo, novaDescricao, tipoAvisoEnum, usuariosSelecionados);
            CarregarAvisos()
            setMensagemAlerta(`Aviso adicionado com sucesso!`);
            setTipoAlerta('success');
        }
        catch (error) {
            setMensagemAlerta(`Erro ao adicionar o Aviso: ${error.response.data}`);
            setTipoAlerta('danger');
        }
        finally {
            FecharModal();
            setLoading(false);
            exibirAlerta();
        }
    }

    async function ObterCoordenadoresAsync() {
        const resposta = await UsuarioApi.ListarUsuariosPorGrupoDeUsuarioAsync(4);
        setCoordenadores(resposta);
    }

    useEffect(() => {
        setLoading(true);
        ObterCoordenadoresAsync();
        setLoading(false);
    }, []);

    useEffect(() => {
        CarregarAvisos(paginaAtual, titulo, descricao);
    }, [paginaAtual, titulo, descricao]);

    const totalPages = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}

                <div className={style.pagina_conteudo}>
                    {/* Cabeçalho da pagina */}
                    <div className={style.container_cabecalho}>
                        <h4>Avisos</h4>
                        <BotaoNovoAtualizado link={ModalAdicionar} />
                    </div>

                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>
                        <InputBuscar
                            type="text"
                            id="hidenTitulo"
                            placeholder="Título"
                            name="titulo"
                            maxLength={30}
                            value={tituloFiltro}
                            onChange={(e) => setTituloFiltro(e.target.value)}
                        />

                        <InputBuscar
                            type="text"
                            id="hidenDescricao"
                            placeholder="Descrição"
                            name="descricao"
                            maxLength={70}
                            value={descricaoFiltro}
                            onChange={(e) => setDescricaoFiltro(e.target.value)}
                        />
                        <div className={style.container_filtro2}>
                            <Button onClick={BuscarAvisos} id={style.botao_buscar}><MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarAvisos} id={style.botao_resetar}><MdClose /> Limpar
                            </Button>


                        </div>

                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Título</th>
                                        <th>Mensagem</th>
                                        <th>Data de Criação</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {avisos.map((aviso) => (
                                        <tr className={style.tabela_corpo} key={aviso.avisoID}>
                                            <td title={aviso.titulo}>{aviso.titulo}</td>
                                            <td title={aviso.descricao}>{aviso.descricao}</td>
                                            <td title={new Date(aviso.dataCriacao).toLocaleString("pt-BR")}>{new Date(aviso.dataCriacao).toLocaleString("pt-BR")}</td>
                                            <td className={style.coluna_acoes}>
                                                <Link onClick={() => ModalVisualizar(aviso)} className={style.botao_visualizar}><IoEyeSharp
                                                    title="Visualizar" />
                                                </Link>
                                                <Link onClick={() => ModalExcluir(aviso)} className={style.botao_deletar}>
                                                    <MdDelete
                                                        title="Deletar" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Controle de Paginação */}
                        <Paginacao
                            paginaAtual={paginaAtual}
                            totalPages={totalPages}
                            onPageChange={(novaPagina) => setPaginaAtual(novaPagina)}
                        />
                    </div>

                    {/* Modal de confirmação */}
                    <Modal show={mostrarModal} onHide={FecharModal}>
                        {adicionar ? <>
                            <Modal.Header closeButton>
                                <Modal.Title>Enviar aviso</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Título</Form.Label>
                                    <InputBuscar maxLength={100} type="text" placeholder="Título" name="titulo" value={novoTitulo} onChange={(e) => setNovoTitulo(e.target.value)} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <textarea maxLength={250} className={`form-control ${style.areaInput}`} rows='3' type="text" placeholder="Descrição" name="descricao" value={novaDescricao} onChange={(e) => setNovaDescricao(e.target.value)} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de Aviso</Form.Label>
                                    {tiposAvisoAdministradorEnum.map((tipo) => (
                                        <Form.Check
                                            key={tipo.key}
                                            type="radio"
                                            label={tipo.value}
                                            name="tipoAviso"
                                            checked={tipoAvisoEnum === tipo.key}
                                            onChange={() => setTipoAvisoEnum(tipo.key)}
                                        />
                                    ))}
                                </Form.Group>

                                {tipoAvisoEnum === 8 && (
                                    <>
                                        <Form.Group controlId="formUsuarios" className="mb-3">
                                            <Form.Label>Selecione os Coordenadores</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={usuariosSelecionados[0] || ""}  // Mantém o valor selecionado
                                                onChange={(e) => {
                                                    const selectedValue = Number(e.target.value); // Converte o valor para número
                                                    if (selectedValue && !usuariosSelecionados.includes(selectedValue)) {
                                                        setUsuariosSelecionados([...usuariosSelecionados, selectedValue]); // Adiciona o monitor selecionado
                                                    }
                                                }}
                                            >
                                                <option value="">Selecione um Coordenador</option>
                                                {coordenadores.filter(coordenador => !usuariosSelecionados.includes(coordenador.id))  // Filtra os selecionados
                                                    .map((coordenador) => (
                                                        <option key={coordenador.id} value={coordenador.id}>
                                                            {coordenador.nome}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <div className={style.usuariosSelecionados}>
                                            {usuariosSelecionados.map((usuarioId) => {
                                                const usuario = coordenadores.find(m => m.id === Number(usuarioId));

                                                return usuario ? (
                                                    <span key={usuario.id} className={style.usuarioTag}>
                                                        {usuario.nome}
                                                        <button
                                                            className={style.removerUsuario}
                                                            onClick={() => setUsuariosSelecionados(usuariosSelecionados.filter(id => id !== usuario.id))}
                                                        >
                                                            <TiDelete size={20} />
                                                        </button>
                                                    </span>
                                                ) : null;
                                            })}
                                        </div>
                                    </>
                                )}

                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary " onClick={FecharModal}>
                                    Cancelar
                                </Button>

                                <Button variant="success" onClick={AdicionarAviso}>
                                    Enviar
                                </Button>
                            </Modal.Footer>
                        </>
                            : null}

                        {visualizar ? (
                            <>
                                <Modal.Header closeButton>
                                    <Modal.Title>Visualizar Aviso</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Título</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={avisoVisualizar.titulo}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={avisoVisualizar.descricao}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Data de Envio</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={new Date(avisoVisualizar.dataCriacao).toLocaleString("pt-BR")}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>

                                    {/* Exibir os usuários que foram notificados */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuários Notificados</Form.Label>
                                        <div className={style.usuariosSelecionados}>
                                            {avisoVisualizar.nomes.map((nome, index) => (
                                                <span key={index} className={style.usuarioTag}>
                                                    {nome}
                                                </span>
                                            ))}
                                        </div>
                                    </Form.Group>
                                </Modal.Body>
                            </>
                        ) : null}

                        {remover ? <>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmar</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                Tem certeza que deseja remover o aviso {avisoSelecionado?.nome}?
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary " onClick={FecharModal}>
                                    Cancelar
                                </Button>

                                <Button variant="danger" onClick={ExcluirAviso}>
                                    Deletar
                                </Button>
                            </Modal.Footer>
                        </>
                            : null}
                    </Modal>
                </div>
            </Topbar>
        </Sidebar>
    )
}

export default Avisos;